import React, { Component } from 'react';

class IconGear extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="13"
                height="15"
                fill="none"
                viewBox="0 0 13 15"
            >
                <path
                    fill="#fff"
                    d="M6.508 5.722c-.438 0-.848.17-1.159.48-.309.31-.48.72-.48 1.159 0 .438.171.848.48 1.159.311.309.721.48 1.16.48.437 0 .847-.171 1.158-.48.309-.311.48-.721.48-1.16 0-.437-.171-.847-.48-1.158a1.625 1.625 0 00-1.159-.48zm6.04 3.45l-.958-.82a5.265 5.265 0 000-1.69l.958-.819a.469.469 0 00.136-.515l-.013-.038a6.483 6.483 0 00-1.166-2.018l-.027-.03a.47.47 0 00-.514-.14l-1.19.424a5.115 5.115 0 00-1.458-.842l-.23-1.244a.47.47 0 00-.378-.377l-.04-.007a6.601 6.601 0 00-2.326 0l-.04.007a.47.47 0 00-.377.377l-.232 1.25c-.525.199-1.014.482-1.448.839l-1.199-.426a.469.469 0 00-.514.139l-.026.03A6.532 6.532 0 00.34 5.29l-.013.038a.47.47 0 00.136.515l.97.828a5.15 5.15 0 000 1.67l-.967.827a.47.47 0 00-.137.516l.014.038a6.5 6.5 0 001.166 2.017l.026.031a.47.47 0 00.514.14l1.198-.427c.437.359.923.643 1.45.84l.23 1.249a.47.47 0 00.379.376l.04.008c.768.138 1.556.138 2.325 0l.04-.008a.47.47 0 00.378-.376l.23-1.244c.53-.2 1.02-.482 1.459-.842l1.19.423a.468.468 0 00.513-.139l.027-.03c.51-.603.9-1.281 1.166-2.018l.013-.038a.473.473 0 00-.14-.513zm-6.04.764a2.575 2.575 0 110-5.15 2.575 2.575 0 010 5.15z"
                ></path>
            </svg>
        );
    }
}

export default IconGear;